<template>
	<div id="prosesOrder" class="font-size-10 font-size-sm-9">
		<div class="row">
			<div class="col-12 pb-2 pl-3 pl-md-3 pr-3 pr-md-3" v-if="dataProduct.length == 0 && Object.values(transactionOne).length > 0">
				Transaksi ini tidak membutuhkan proses serial. Silahkan proses transaksi dengan langsung klik tombol proses order
				<!-- <vcl :width='430' :height='25'>
					<rect x="0" y="2" rx="2" ry="2" width="430" height="20" />
				</vcl> -->
			</div>
			<div class="col-12 pb-3 pl-3 pl-md-3 pr-3 pr-md-3" v-if="dataProduct.length > 0">
				<div class="col-12 bg-outline-purple bg-purple-light rounded pt-2 pb-2">
					<div class="text-purple font-size-11"><i class="fas fa-exclamation-circle mr-2"></i>Silahkan Pilih Serial Yang Akan Dijual Dengan Kode Transaksi {{transactionOne.trx_code}}</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-md-12 pb-3">
				<div class="row">
					<div class="col-sm-12 col-md-12 col-lg-12 mt-4 background-white rounded cus-box-shadow" v-show="false">
						<vcl :width='400' :height='130'>
							<rect x="6" y="6" rx="2" ry="2" width="80" height="13" />
							<rect x="200" y="6" rx="2" ry="2" width="80" height="13" />
							<rect x="75" y="25" rx="2" ry="2" width="47" height="12" />
							<rect x="125" y="25" rx="2" ry="2" width="47" height="12" />
							<rect x="270" y="25" rx="2" ry="2" width="47" height="12" />
							<rect x="320" y="25" rx="2" ry="2" width="47" height="12" />
							<rect x="6" y="50" rx="2" ry="2" width="12" height="12" />
							<rect x="200" y="50" rx="2" ry="2" width="180" height="70" />
							<rect x="30" y="50" rx="2" ry="2" width="150" height="12" />
							<rect x="6" y="68" rx="2" ry="2" width="12" height="12" />
							<rect x="30" y="68" rx="2" ry="2" width="150" height="12" />
							<rect x="6" y="86" rx="2" ry="2" width="12" height="12" />
							<rect x="30" y="86" rx="2" ry="2" width="150" height="12" />
							<rect x="6" y="106" rx="2" ry="2" width="12" height="12" />
							<rect x="30" y="106" rx="2" ry="2" width="150" height="12" />
						</vcl>
					</div>
				</div>
				<div class="row" v-if="dataProduct.length > 0">
					<div class="col-12 text-center">
						<div class="pb-2 font-size-10">Silahkan Scan Serial Produk</div>
						<div class="d-flex flex-wrap justify-content-center">
							<div class="col-12 col-md-6 p-4 container-scanner">
								<div class="scan-icon-top-left"><img src="/assets/icon/scan-icon.png"></div>
								<QrcodeStream @decode="onDecode"></QrcodeStream>
								<div class="scan-icon-bot-right"><img src="/assets/icon/scan-icon.png"></div>
							</div>
							<div class="col-12 px-0 pt-3 form-group mb-2 d-flex justify-content-center">
								<!-- <input v-model="serial_input" @keypress.enter="cariSerial" class="range-badge-serial form-control-sm col-4 col-md-3 font-size-sm-9"> -->
								<v-select v-model="serial_input" :options="serialOwnedList" class="range-badge-serial col-8 col-md-4 font-size-sm-9" label="stock_serial_value" taggable :create-option="el => ({ stock_serial_value: el})" :reduce="el => `${el.stock_serial_value}`" @input="cariSerial">
									<template v-slot:no-options>
										Saat ini tidak ada serial yang tersedia
									</template>
								</v-select>
								<button @click="cariSerial" class="ml-2 btn btn-mila text-white font-size-sm-10 box-purple">
									<div class="font-size-9 font-size-sm-9">Cari</div>
								</button>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-sm-12 pl-3 pr-3 pl-md-3 pr-md-3 background-white rounded" v-for="(data, index) in dataProduct" :key="index">
						<div class="row">
							<div class="pl-4 pr-4">
								<div class="row pr-md-2">
									<div class="pt-1 pb-1 font-size-9 serial-badge-product">
										<span class="font-size-11">{{data.product.code}}</span>
									</div>
									<div class="pt-1 pb-1 mt-2 font-size-9 serial-badge-product">
										<span class="font-size-11">{{data.serial_name}} Terpilih ({{data.listSelected.length}} dari {{data.totalNeeded}})</span>
									</div>
									<div class="col-lg-12 pt-3 mt-3 pb-3 border-2 rounded pl-2 pr-2 ml-2 mb-4 serial-border">
										<div class="row">
											<div class="col-6 pl-4 pr-0">
												<label class="container-serial">Pilih Semua
													<input v-model="data.removeAll" type="checkbox" @input="checkSerialSelected(index, $event)">
													<span class="checkmark"></span>
												</label>
											</div>
											<div class="col-6 pl-lg-4 mt-n1 text-center">
												<button @click="removeSelected({index: index, product: data.product, serial: data.allSelected})" class="btn btn-link-red pl-lg-2 pl-0 pl-md-3 pr-md-2 pr-0 pt-1 font-size-10 font-size-sm-9 box-purple">Batalkan Terpilih</button>
											</div>
										</div>
										<!-- data kosong -->
										<div class="row" v-if="data.listSelected.length == 0">
											<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3">
												<div class="col-12 p-0 pb-2">
													<div class="col-12 p-0 d-flex pb-2 pl-4">
														<div class="col-12 p-0">
															<div class="row">
																<div class="col-md-12 col-12 mt-5 text-center">
																	<img src="assets/icon/stock_empty.svg" width="100px;" class="mt-n3">
																	<p class="mb-n1 font-size-sm-11 font-size-12">Belum Ada Serial Terpilih</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="row" v-else>
											<div class="col-12">
												<div class="row">
													<div class="col-11 pl-4 mt-2 mb-2 pt-1 serial-body">
														<div :id="'container-selected'+index">
															<label class="container-serial d-flex" v-for="val in data.listSelected" :key="val">
																<span class="serial-item">{{val}}</span>
																<input v-model="data.allSelected" type="checkbox" :value="val">
																<span class="checkmark mt-c04"></span>
																<button @click="removeSelected({index: index, product: data.product, serial: [val]})" class="btn btn-del-serial text-white"><i class="fas fa-minus-circle"></i></button>
															</label>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { QrcodeStream } from 'vue-qrcode-reader'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
	components: {
		QrcodeStream, vSelect
	},
	data(){
		return{
			minSelectedSerial:'',
			maxSelectedSerial:'',
			dataSerial:[],
			dataSerialTemp:[],
			selectAllSerialTerpilih:[],
			selected:[],
			selectedTerpilih:[],
			allProductSelected:[],
			serial_input: '',
		}
	},
	computed:{
		...mapState('transactionList', ['transactionOne', 'dataProduct', 'serialOwnedList']),
		...mapGetters('auth', ['isAuth']),

		serialText(){
			var serial_text = ''
			this.dataProduct.forEach( (element, index) => {
				if (index == 0) {
					serial_text += `${element.quantity} (${element.code}) `
				} else if (index == (this.dataProduct.length -1)) {
					serial_text += `dan ${element.quantity} (${element.code})`
				} else {
					serial_text += `, ${element.quantity} (${element.code}) `
				}
			})
			return serial_text
		}
	},
	methods:{
		...mapMutations('transactionList', ['listTempSerial', 'selectTempSerial', 'removeSelected', 'removeTempSerial', 'selectAll', 'removeAll', 'loadMoreSerial']),
		...mapActions('transactionList', ['checkSerialMLM', 'scanLinkSerial', 'getSerialOwnedList']),

		onDecode(val) {
			if (val) {
				this.scanLinkSerial(val).then( ({ data }) => {
					this.serial_input = data.serial
					this.cariSerial()
				})
			}
		},
		cariSerial() {
			if (this.serial_input) {
				this.checkSerialMLM({
					serial: this.serial_input
				})
			}
		},
		toupper(index, val){
			if(val == 'min') {
				this.serialFilter[index].serialmin = this.serialFilter[index].serialmin.toUpperCase()
			} else {
				this.serialFilter[index].serialmax = this.serialFilter[index].serialmax.toUpperCase()
			}
			
		},
		tryScroll(index, type) {
			var body = type == "list" ? "serial-body" : "serial-body-selected"
			var content = type == "list" ? "container" : "container-selected"
			var id = document.getElementById(body+index);
			var container = document.getElementById(content+index);
			var scroll = id.scrollTop
			if ((scroll) > (container.clientHeight - id.clientHeight)) {
				this.loadMoreSerial({
					index: index,
					type: type
				})
			}
		},
		checkSerial(i, $event){
			const checked = $event.target.checked
			this.selectAll({
				index: i,
				value: checked
			})
		},
		checkSerialSelected(i, $event){
			const checked = $event.target.checked
			this.removeAll({
				index: i,
				value: checked
			})
		},
		selectAllSerial(value, index) {
			let arraySer = []
			arraySer[index] = value
			let allSerial = []

			if (!this.allProductSelected[index]) {
				this.selected = arraySer[index].serial.map(function(val) {
					allSerial.push({ id: value.id, serial: [val] })
					return val
				});
				this.dataSerial = allSerial
			} else {
				this.selected = arraySer[index].serial.map((val) => !val); 
				this.dataSerial = this.dataSerial.filter(function( obj ) {
					return obj.serial[0] !== value.serial[0];
				});
			} 
		},
		// selectAllSerialTemp(value, index) {
		// 	let arrayTemp = []
		// 	arrayTemp[index] = value
		// 	let allSerialTemp = []

		// 	if (!this.selectAllSerialTerpilih[index]) {
		// 		this.selectedTerpilih = arrayTemp[index].serial.map(function(valu) {
		// 			allSerialTemp.push({ id: value.id, serial: [valu] })
		// 			return valu
		// 		});
		// 		this.dataSerialTemp = allSerialTemp

		// 	} else {
		// 		this.selectedTerpilih = arrayTemp[index].serial.map(() => !value); 
		// 		this.dataSerialTemp = this.dataSerialTemp.filter(function( obj ) {
		// 			return obj.serial[0] !== value.serial[0];
		// 		});
		// 	} 
		// },
	},
	created() {
		let serial_type_list = []
		this.dataProduct.forEach(el => {
					serial_type_list.push(el.type_id)
		})
		let params = [{
			value: serial_type_list.join('::'),
			comparison: 'yes',
			type: 'list',
			field: 'stock_serial_type',
		}, {
			value: '0',
			comparison: '=',
			type: 'string',
			field: 'stock_serial_status',
		}, {
			value: 'store',
			comparison: '=',
			type: 'string',
			field: 'stock_serial_used_for',
		},
		];
		this.getSerialOwnedList(this.queryString({params: params, limit: 100000}))
	}
}
</script>

<style>
.btn-link-red{
	color: #ea1c0d;
}
.container-serial {
	display: block;
	position: relative;
	padding-left: 35px;
	margin-bottom: 12px;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}
.container-serial-skeleton {
	display: block;
	position: relative;
	margin-bottom: 12px;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}
.container-serial input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}
.checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #eee;
	border-radius: 4px;
}
.container-serial:hover input ~ .checkmark {
	background-color: #ccc;
}
.container-serial input:checked ~ .checkmark {
	background-color: #23ae9b;
}
.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}
.container-serial input:checked ~ .checkmark:after {
	display: block;
}
.container-serial .checkmark:after {
	left: 7px;
	top: 3px;
	width: 7px;
	height: 11px;
	border: solid white;
	border-width: 0 3px 3px 0;
	-webkit-transform: rotate(45deg);
	-ms-transform: rotate(45deg);
	transform: rotate(45deg);
}
.bg-purple-light {
	background-color: #f7eff7;
}
/* Custom Margin */
.mt-c04 {
	margin-top: .4em;
}
.btn-green {
	background-color: #23ae9b;
}
.btn-add-serial {
	background-color: #23ae9b;
	position: absolute;
	top: 0;
	right: 0;
	padding-top: 3px;
	padding-bottom: 4px;
	padding-left: 9px;
	padding-right: 9px;
}
.btn-del-serial {
	background-color: #ea1c0d;
	position: absolute;
	top: 0;
	right: 0;
	padding-top: 3px;
	padding-bottom: 4px;
	padding-left: 9px;
	padding-right: 9px;
}
.range-badge-serial {
	border: 1px solid #aeaeae;
	border-radius: 5px;
	padding: 8px 8px 8px 8px;
}
.range-strip-serial {
	width: 17px;
	height: 1px;
	background-color: #aeaeae;
	display: inline-block;
	margin-top: .9rem;
}
.serial-ka{
	border-top: 30px solid #7C1CC6;
}
.serial-ro{
	border-top: 30px solid #7C1CC6;
}
.serial-badge {
	width: 16em;
	height: 0;
	border-right: 15px solid transparent;
}
.serial-badge2 {
	width: 100%;
	height: 0;
	border-right: 15px solid transparent;
}
.serial-badge-text {
	position: absolute;
	margin-top: -2.1em;
	margin-left: -5.6em;
	color: #fff;
}
.serial-badge-text2 {
	position: absolute;
	margin-top: -2.1em;
	margin-left: -6.6em;
	color: #fff;
}
.serial-badge-product {
	background-color: #7c1cc6;
	padding-left: 8px;
	padding-right: 8px;
	color: white;
	width: 100%;
	border-radius: 10px;
}
.serial-item {
	display: inline-block;
	width: 100%;
	background-color: #f1f1f1;
	padding-top: .5em;
	padding-bottom: .5em;
	padding-left: 1em;
	border-radius: 5px;
}
.serial-body {
	max-height: 227px;
	overflow-y: auto;
}
.btn-link-green {
	color: #23ae9b;
}
.border-2 {
	border: 2px solid #f1f1f1;
}
.serial-border {
	min-height: 23.3em;
}
.qrcode-stream-wrapper video {
	transform: scaleX(-1) !important;
}
</style>